import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "h4 text-primary" }, "Add New Document", -1)
const _hoisted_3 = { class: "row pt-2" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xs-12 col-md-6 form-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Document Name", -1)
const _hoisted_8 = { class: "col-xs-12 col-md-6 form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Version", -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-xs-12 col-md-6 form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Document", -1)
const _hoisted_13 = ["onChange", "onBlur"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("small", null, "File Type Allowed: .doc,.docx,.pdf", -1)
const _hoisted_15 = { class: "col-xs-12 col-md-6 form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Department/Employees", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-xs-12 col-md-6 form-group" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "" }, "Department Assigned", -1)
const _hoisted_21 = { class: "row my-3 justify-content-center" }
const _hoisted_22 = { class: "col-xs-12 col-sm-5 col-lg-5 col-xl-4 col-md-6 form-group" }
const _hoisted_23 = { class: "col-xs-12 col-sm-5 col-lg-5 col-xl-4 col-md-6 form-group" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, " Save ", -1)
const _hoisted_26 = { class: "spinner-border spinner-border-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { crumbs: _ctx.crumbs }, null, 8, ["crumbs"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, null, {
        title: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Form, {
            onSubmit: _ctx.save,
            "validation-schema": _ctx.schema
          }, {
            default: _withCtx((meta) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_input_field, { icon: "id-card" }, {
                    input: _withCtx(() => [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "name",
                        placeholder: "Enter Document Name",
                        id: "name",
                        class: _normalizeClass(meta.errors.name ? 'is-invalid' : ''),
                        modelValue: _ctx.newDocument.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newDocument.name) = $event))
                      }, null, 8, ["class", "modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "name",
                        class: "invalid-feedback"
                      })
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_input_field, { icon: "id-card" }, {
                    input: _withCtx(() => [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "version",
                        placeholder: "Enter Version",
                        id: "version",
                        class: _normalizeClass(meta.errors.version ? 'is-invalid' : ''),
                        modelValue: _ctx.newDocument.version,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newDocument.version) = $event))
                      }, null, 8, ["class", "modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "version",
                        class: "invalid-feedback"
                      })
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_Field, { name: "file" }, {
                    default: _withCtx(({ handleChange, handleBlur }) => [
                      _createElementVNode("input", {
                        accept: ".doc,.docx,.pdf",
                        class: _normalizeClass([meta.errors.file ? 'is-invalid' : '', "border bg-white rounded d-block w-100 p-1 shadow-sm"]),
                        ref: "uploadDocument",
                        type: "file",
                        onChange: handleChange,
                        onBlur: handleBlur
                      }, null, 42, _hoisted_13)
                    ]),
                    _: 2
                  }, 1024),
                  _hoisted_14,
                  _createVNode(_component_ErrorMessage, {
                    name: "file",
                    class: "invalid-feedback"
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _hoisted_17,
                  _createElementVNode("label", {
                    class: _normalizeClass(`btn mr-2 ${
                  _ctx.picked === 'Department'
                    ? 'btn-primary'
                    : 'btn-outline-primary'
                }`)
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      hidden: "",
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.rdChange())),
                      value: 'Department',
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.picked) = $event)),
                      name: "selectEmpDept",
                      autocomplete: "off"
                    }, null, 544), [
                      [_vModelRadio, _ctx.picked]
                    ]),
                    _createTextVNode(" Department ")
                  ], 2),
                  _createElementVNode("label", {
                    class: _normalizeClass(`btn ${
                  _ctx.picked === 'Employee' ? 'btn-primary' : 'btn-outline-primary'
                }`)
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      hidden: "",
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.rdChange())),
                      value: 'Employee',
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.picked) = $event)),
                      name: "selectEmpDept",
                      autocomplete: "off"
                    }, null, 544), [
                      [_vModelRadio, _ctx.picked]
                    ]),
                    _createTextVNode(" All Employees ")
                  ], 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_Dropdown, {
                    size: "lg",
                    options: _ctx.departments,
                    modelValue: _ctx.newDocument.departmentAssigned,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newDocument.departmentAssigned) = $event)),
                    placeholder: "Select a department",
                    icon: "building",
                    fields: ['id', 'name'],
                    clearable: ""
                  }, null, 8, ["options", "modelValue"])
                ], 512), [
                  [_vShow, _ctx.showDept]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.$router.push('/admin/documents/manage')), ["prevent"])),
                    type: "button",
                    class: "btn-secondary btn-lg-cus"
                  }, " Cancel ")
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    class: "btn-primary btn-lg-cus",
                    disabled: _ctx.loading,
                    type: "submit"
                  }, [
                    _hoisted_25,
                    _withDirectives(_createElementVNode("span", _hoisted_26, null, 512), [
                      [_vShow, _ctx.loading]
                    ])
                  ], 8, _hoisted_24)
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ]),
    _createVNode(_component_ConfirmationModal, { ref: "confirmDialogue" }, null, 512)
  ], 64))
}